const SelectionListener = (onAdd, onRemove) => {
  // Listen for messages, specifically whether the Schema.org class selection has changed.
  window.addEventListener(
    "message",
    ({ data, origin }) => {
      // Bail out if message isn't coming from our page.
      if (0 !== document.location.href.indexOf(origin)) return;

      if (data.selected)
        Promise.resolve(data.selected).then(onAdd(data.selected));

      if (data.deselected)
        Promise.resolve(data.deselected).then(onRemove(data.deselected));
    },
    false
  );
};

export default SelectionListener;
